import { useMutation } from '@tanstack/react-query';
import { Col, Row } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { DefaultOptionType } from 'antd/es/select';
import axiosGraphQL from 'apis/GraphQL/axiosGraphQL';
import { GET_ALL_PLANT } from 'apis/GraphQL/Queries/plantQuery';
import { IUpdateHotRewardAmount } from 'apis/GraphQL/Variables/RewardCalculationVariables';
import { RewardCalculationApis } from 'apis/RewardCalculationApis';
import { IconLoading, LockIcon, UnlockIcon } from 'assets/svg';
import { Button, ButtonFilter } from 'components';
import ButtonImport from 'components/Button/ButtonImport';
import { TMenuPropsCustom } from 'components/Button/ExportOptionsButton';
import { RewardOptionsButton } from 'components/Button/RewardOptionsButton';
import { UploadModal } from 'components/UploadModal_V2';
import { useTitle } from 'contexts/TitleProvider';
import { useUser } from 'contexts/UserProvider';
import dayjs from 'dayjs';
import useDefaultFilterReward from 'hooks/useDefaultFilterReward';
import useQueryParam from 'hooks/useQueryPrams';
import { IParamQraphQL } from 'interfaces/GraphQL/GraphQL';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { DEFAULT_PAGE_SIZE } from 'utils/constants/constant';
import { exportExcel_v2 } from 'utils/constants/exportExcel';
import { toastError, toastSuccess } from 'utils/constants/functions';
import { IMPORT_REWARD_CALCULATION } from 'utils/constants/importId';
import BonusModal from './Bonus';
import FilterRewardCalculation from './FilterRewardCalculation';
import ModalRewardSetup from './ModalRewardSetup';
import TableRewardCalculation from './TableRewardCalculation';

const RewardCalculationPage = () => {
  const { user } = useUser();
  const navigate = useNavigate();
  const { setTitle, setBreadcrumb } = useTitle();
  const childRef = useRef<any>(null);
  const [isOpenFilter, setIsOpenFilter] = useState(false);
  const [formParams, setFormParams] = useState<any>({});
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [formTable] = useForm();
  const [dataTable, setDataTable] = useState<any>({});
  const [indexHandle, setIndexHandle] = useState<number>(-1);
  const [isOpenImportModal, setIsOpenImportModal] = useState<boolean>(false);
  const [optionsBranch, setOptionsBranch] = useState<DefaultOptionType[]>([]);
  const [isOpenBonusModal, setIsOpenBonusModal] = useState<boolean>(false);
  const [isLock, setLock] = useState<boolean>(!(user?.isAdmin || user?.isHO));

  const queryParam = useQueryParam();
  const page = parseInt(queryParam.get('page') + '') || 1;
  const page_size =
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;

  const mutateUpdateHotRewardAmount = useMutation({
    mutationFn: RewardCalculationApis.updateHotRewardAmount,
    onSuccess: (res) => {
      toastSuccess('Cập nhật thành công');
      refetchGetReward();
      handleCancel();
    },
    onError: (error) => {
      toastError(error?.message || 'Cập nhật thất bại');
    },
  });

  const defaultFilter = useDefaultFilterReward();

  const menuProps: TMenuPropsCustom = {
    items: [
      {
        key: '1',
        label: 'Chi thưởng',
        handleExport: () => handleExportExcel(),
      },
      // {
      //   key: '2',
      //   label: '',
      //   handleExport: () =>console.log(''),
      // },
    ],
  };

  const handleSuccess = (res: any) => {
    if (!res?.data) {
      toastError(res?.errors[0]?.message || 'Tính thưởng thất bại');
    } else {
      toastSuccess('Tính thưởng thành công');
      refetchGetReward();
    }
  };

  const handleError = (error: any) => {
    toastError(error?.message || 'Tính thưởng thất bại');
  };

  const {
    mutate: calculateRewardForTeam,
    isPending: calculateRewardForTeamLoading,
  } = useMutation({
    mutationFn: RewardCalculationApis.calculateRewardForTeam,
    onSuccess: handleSuccess,
    onError: handleError,
  });

  const {
    mutate: calculateRewardForPlant,
    isPending: calculateRewardForPlantLoading,
  } = useMutation({
    mutationFn: RewardCalculationApis.calculateRewardForPlant,
    onSuccess: handleSuccess,
    onError: handleError,
  });

  const mutateGetReward = useMutation({
    mutationFn: RewardCalculationApis.getRewardCalculation,
    onSuccess: (res, variables) => {
      // console.log('res mutateGetReward',res);
      const result = res?.data?.getReward;
      // console.log('result mutateGetReward', result);
      if (variables.type === 'export') {
        exportExcel_v2(
          variables.headerRow,
          result.items || [],
          'Bảng tính thưởng theo tháng',
        );
      } else {
        setDataTable(result);
      }
    },
    onError: (error) => {
      console.log('error mutateGetReward', error);
    },
  });

  const refetchGetReward = useCallback(
    async (isExport?: boolean, headerRow?: any) => {
      try {
        await mutateGetReward.mutateAsync({
          page: isExport ? 1 : page,
          page_size: isExport
            ? dataTable?.pageInfo?.totalItems || 1000
            : page_size,
          ...(defaultFilter && {
            ...defaultFilter,
            plantId: defaultFilter?.plantId
              ? defaultFilter?.plantId.replace('all', '')
              : undefined,
          }),
          ...(formParams && formParams),
          ...(isExport && {
            headerRow,
            type: 'export',
          }),
        });
      } catch (error) {
        console.log('mutateGetReward', error);
      }
    },
    [
      page,
      dataTable?.pageInfo?.totalItems,
      page_size,
      defaultFilter,
      formParams,
    ],
  );

  useEffect(() => {
    refetchGetReward();
  }, [refetchGetReward]);

  const mutationBranch = useMutation({
    mutationKey: ['getAllBranch'],
    mutationFn: (params: IParamQraphQL) =>
      axiosGraphQL.post('/graphql', params),
    onSuccess: (res) => {
      setOptionsBranch(
        res.data?.getPlant
          ? res.data?.getPlant.items.map((item: any) => ({
              label: item.id,
              value: item.id,
            }))
          : [],
      );
    },
    onError: (error) => {
      console.log(error);
    },
  });

  useEffect(() => {
    setTitle('Bảng tính thưởng theo tháng');
    setBreadcrumb([
      { title: 'Doanh thu/ Thưởng' },
      { title: 'Bảng tính thưởng theo tháng' },
    ]);
    if (user?.isAdmin || user?.isHO) {
      mutationBranch.mutate({
        query: GET_ALL_PLANT,
        variables: {
          input: {
            id: {
              not: '5000',
            },
          },
        },
      });
    }
  }, [setTitle, setBreadcrumb, user]);

  const handleExportExcel = () => {
    if (childRef.current) {
      childRef.current.exportExcel();
    }
  };

  const handleImport = () => {
    // console.log('import');
    setIsOpenImportModal(true);
  };

  const handleOkFilter = useCallback(
    (values: any) => {
      console.log(values);
      navigate(`?page=1&page_size=${page_size}`);
      setFormParams({
        ...values,
        plantId: values?.plantId
          ? values?.plantId.replace('all', '')
          : undefined,
      });
    },
    [page_size],
  );

  const handleCancelFilter = useCallback(() => {
    console.log('Cancel Filter');
    setFormParams({});
  }, []);

  const handleCancel = () => {
    // setIsAdd(false);
    setIndexHandle(-1);
    formTable.resetFields();
  };

  const handleAddRow = () => {
    // setIsAdd(true);
    setIndexHandle(0);
    setDataTable((pre: any) => ({
      ...pre,
      items: [{ id: Date.now() }].concat(pre.items),
    }));
  };

  const handleCancelTable = () => {
    // if (isAdd) {
    //   setDataTable((pre: any) => ({
    //     ...pre,
    //     items: (pre?.items || []).slice(1),
    //   }));
    // }
    handleCancel();
  };

  const handleSaveTable = () => {
    const values = formTable.getFieldsValue();
    delete values.totalExpenEndPeriod;
    const item = dataTable.items[indexHandle];

    const data: IUpdateHotRewardAmount = {
      ...values,
      rewardId: item.id,
    };

    mutateUpdateHotRewardAmount.mutate(data);
  };

  const handleEditRow = (index: number) => {
    setIndexHandle(index);
    // setIsAdd(false);
    const row = dataTable?.items?.[index];
    formTable.setFieldsValue(row);
  };

  const handleOnClickRewardCalc = async () => {
    const fromDate = dayjs(formParams.fromDate).startOf('month');
    const toDate = dayjs(formParams.toDate).endOf('month');

    const fromMonth = Number(fromDate.format('MM'));
    const toMonth = Number(toDate.format('MM'));

    const fromYear = Number(fromDate.format('YYYY'));
    const toYear = Number(toDate.format('YYYY'));

    if (user?.isSale) {
      if (user.teamSales?.length > 0)
        calculateRewardForTeam({
          teamSalesId: user.teamSales[0].id,
          fromMonth,
          toMonth,
          fromYear,
          toYear,
        });
    } else {
      const plantId: string[] = [];

      if (user?.isAdmin || user?.isHO) {
        plantId.push(
          ...optionsBranch
            .filter((item) => item.value)
            .map((item) => String(item.value)),
        );
      } else {
        plantId.push(user?.plantId);
      }

      calculateRewardForPlant({
        plantId,
        fromMonth,
        toMonth,
        fromYear,
        toYear,
      });
    }

    // const result = await Promise.all([
    //   mutateRewardCalc.mutateAsync({
    //     userId: '39',
    //     fromDate: dayjs().startOf('month').toDate(),
    //     toDate: dayjs().endOf('month').toDate(),
    //   }),
    //   mutateRewardCalc.mutateAsync({
    //     userId: '66',
    //     fromDate: dayjs().startOf('month').toDate(),
    //     toDate: dayjs().endOf('month').toDate(),
    //   }),
    // ]);

    // const isSuccess = result.every((item) => (item.errors?.length || []) !== 0);

    // if (isSuccess) {
    //   toastSuccess('Tính thưởng thành công!');
    //   refetchGetReward();
    // } else {
    //   toastError('Tính thưởng thất bại!');
    // }
  };

  return (
    <>
      <Row gutter={[8, 16]} align={'middle'} justify={'end'}>
        <Col>
          <ButtonFilter isOpen={isOpenFilter} setIsOpen={setIsOpenFilter} />
        </Col>
        <Col>
          <Button
            disabled={!(user?.isAdmin || user?.isHO || user?.isNS)}
            customClass="px-3 hover:!bg-transparent"
            title={isLock ? <LockIcon /> : <UnlockIcon />}
            onClick={() => setLock(!isLock)}
          />
        </Col>
        <Col>
          <RewardOptionsButton menuProps={menuProps} />
        </Col>
        {/* <Col>
          <ButtonExport onClick={handleExportExcel} />
        </Col> */}
        <Col>
          <ButtonImport onClick={handleImport} disabled={isLock} />
        </Col>
        <Col>
          <Button
            fill
            title="Điều chỉnh"
            iconBefore={<IconLoading />}
            handleOnclick={() => setIsOpenModal(true)}
            disabled={isLock}
          />
        </Col>
        <Col>
          <Button
            fill
            title="Tính thưởng"
            iconBefore={<IconLoading />}
            // customClass="!bg-[#003056] disabled:!opacity-50"
            handleOnclick={handleOnClickRewardCalc}
            disabled={isLock}
          />
        </Col>
      </Row>
      <FilterRewardCalculation
        isOpen={isOpenFilter}
        defaultFilter={defaultFilter}
        onFinish={handleOkFilter}
        onCancel={handleCancelFilter}
        optionsBranch={optionsBranch}
      />

      <TableRewardCalculation
        disabledEdit={isLock}
        ref={childRef}
        form={formTable}
        data={dataTable}
        // isAdd={isAdd}
        // setIsAdd={setIsAdd}
        indexHandle={indexHandle}
        // setIndexHandle={setIndexHandle}
        onCancel={handleCancelTable}
        onEdit={handleEditRow}
        onSave={handleSaveTable}
        loading={
          mutateGetReward.isPending ||
          calculateRewardForTeamLoading ||
          calculateRewardForPlantLoading
        }
        refetch={refetchGetReward}
      />

      <ModalRewardSetup
        isOpen={isOpenModal}
        setIsOpen={setIsOpenModal}
        optionsBranch={optionsBranch}
        refetchGetReward={refetchGetReward}
      />

      <UploadModal
        importId={IMPORT_REWARD_CALCULATION}
        templateFileName="Bảng tính thưởng"
        open={isOpenImportModal}
        title={'Thêm mới bảng tính thưởng'}
        setOpen={setIsOpenImportModal}
        refetch={refetchGetReward}
      />

      <BonusModal
        open={isOpenBonusModal}
        onClose={() => setIsOpenBonusModal(false)}
        refresh={refetchGetReward}
      />
    </>
  );
};

export default RewardCalculationPage;
